export default __webpack_public_path__ + "static/media/usersGroup.542236ee.svg";